var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { Progress } from './types';
export var init = function init() {
  return {
    progress: Progress.Init
  };
};
export var inProgress = function inProgress() {
  return {
    progress: Progress.InProgress
  };
};
export var success = function success(payload, invalidated) {
  return {
    invalidated: invalidated != null ? invalidated : false,
    payload: payload,
    progress: Progress.Success
  };
};
export var error = function error(errorObj) {
  return {
    error: errorObj,
    progress: Progress.Error
  };
};
export var isInit = function isInit(f) {
  return f.progress === Progress.Init;
};
export var isInProgress = function isInProgress(f) {
  return f.progress === Progress.InProgress;
};
export var isSuccess = function isSuccess(f) {
  return f.progress === Progress.Success;
};
export var isValidSuccess = function isValidSuccess(f) {
  return isSuccess(f) && !f.invalidated;
};
export var isInvalidated = function isInvalidated(f) {
  return isSuccess(f) && f.invalidated === true;
};
export var isInProgressOrInvalidated = function isInProgressOrInvalidated(f) {
  return isInProgress(f) || isInvalidated(f);
};
export var isError = function isError(f) {
  return f.progress === Progress.Error;
};
export var isAnyInit = function isAnyInit() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (f) {
    return isInit(f);
  });
};
export var isAnyInProgress = function isAnyInProgress() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (f) {
    return isInProgress(f);
  });
};
export var isAnySuccess = function isAnySuccess() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (f) {
    return isSuccess(f);
  });
};
export var isAnyValidSuccess = function isAnyValidSuccess() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (f) {
    return isValidSuccess(f);
  });
};
export var isAnyInvalidated = function isAnyInvalidated() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (f) {
    return isInvalidated(f);
  });
};
export var isAnyInProgressOrInvalidated = function isAnyInProgressOrInvalidated() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (f) {
    return isInProgressOrInvalidated(f);
  });
};
export var isAnyError = function isAnyError() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.some(function (f) {
    return isError(f);
  });
};
export var safeSuccess = function safeSuccess(origin) {
  if (origin != null && isSuccess(origin)) {
    return origin;
  }

  throw new Error('Invalid cast from Async to SuccessAsync');
};
export var safePayload = function safePayload(origin) {
  return safeSuccess(origin).payload;
};
export var payloadOrUndefined = function payloadOrUndefined(origin) {
  return origin && isSuccess(origin) ? origin.payload : undefined;
};
export var invalidate = function invalidate(origin) {
  return origin.invalidated ? origin : __assign({}, origin, {
    invalidated: true
  });
};
export var invalidateOrSetInProgress = function invalidateOrSetInProgress(origin) {
  return isSuccess(origin) ? invalidate(origin) : inProgress();
};
export var update = function update(origin, updatePayload, invalidated) {
  return success(updatePayload(origin.payload), invalidated != null ? invalidated : origin.invalidated);
};
export var mapIfSuccessOrKeep = function mapIfSuccessOrKeep(origin, mapper) {
  return isSuccess(origin) ? success(mapper(origin.payload), origin.invalidated) : origin;
};
export var renderIfSuccessOrNull = function renderIfSuccessOrNull(origin, renderSuccess) {
  return isSuccess(origin) ? renderSuccess(origin.payload, origin.invalidated) : null;
};
export var renderIfErrorOrNull = function renderIfErrorOrNull(origin, renderError) {
  return isError(origin) ? renderError(origin.error) : null;
};
export var render = function render(origin, name, renderInit, renderInProgress, renderSuccess, renderError) {
  switch (origin.progress) {
    case Progress.Init:
      return renderInit === undefined ? "Not started " + name : renderInit();

    case Progress.InProgress:
      return renderInProgress === undefined ? name + "..." : renderInProgress();

    case Progress.Success:
      var payload = origin.payload,
          invalidated = origin.invalidated;
      return renderSuccess === undefined ? "Success " + name + "!:\n" + (typeof payload === 'object' ? JSON.stringify(payload, null, 2) : String(payload)) : renderSuccess(payload, invalidated);

    case Progress.Error:
      // tslint:disable-next-line:no-console
      console.error('async data render', origin.error);
      return renderError === undefined ? "Error " + name + ": " + origin.error.message : renderError(origin.error);
  }
};
export function task(asyncFunction, callback, options) {
  if (options === void 0) {
    options = {};
  }

  return __awaiter(this, void 0, void 0, function () {
    var result, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          callback(options.currentState ? invalidateOrSetInProgress(options.currentState) : inProgress());
          options.onChange && options.onChange();
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , asyncFunction()];

        case 2:
          result = _a.sent();
          callback(success(result));
          options.onChange && options.onChange();

          if (options.onChange) {
            options.onChange();
          }

          options.onSuccess && options.onSuccess(result);
          return [3
          /*break*/
          , 4];

        case 3:
          err_1 = _a.sent(); // tslint:disable-next-line:no-console

          console.error('asyncTask', err_1);
          callback(error(err_1));
          options.onChange && options.onChange();
          options.onError && options.onError(err_1);
          return [3
          /*break*/
          , 4];

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
}